<script setup>
import { ref } from 'vue';
import SingleTextDisapprovalModal from './SingleTextDisapprovalModal.vue';
import SuccessModal from './SuccessModal.vue';

const inputValue = defineModel({
  type: String,
  required: true,
});

const emit = defineEmits(['close', 'confirm']);
const showSuccessModal = ref(false);

const handleConfirm = () => {
  emit('confirm');
  showSuccessModal.value = true;
};
</script>

<template>
  <SingleTextDisapprovalModal
    v-if="!showSuccessModal"
    v-model="inputValue"
    @close="emit('close')"
    @confirm="handleConfirm"
  >
    <slot />

    <template #label>
      <slot name="label" />
    </template>
  </SingleTextDisapprovalModal>

  <SuccessModal
    v-else
    @close="emit('close')"
  />
</template>
